import {z} from 'zod';

/**
 * Request schema for getting original file from storage service
 */
export const storageOriginalFileRequestSchema = z.object({
  namespace: z.string().optional(),
  variantName: z.string().optional(),
});

export type StorageOriginalFileRequest = z.infer<typeof storageOriginalFileRequestSchema>;
